{
  "page": {
    "title": "Administration",
    "tabs": {
      "users": "Users",
      "scraping": "Scraping Jobs",
      "mortgage": "Mortgage",
      "translations": "Translations"
    },
    "createUser": "Create User",
    "failedToLoadUsers": "Failed to load users",
    "userUpdated": "User updated successfully",
    "userCreated": "User created successfully",
    "failedToSaveUser": "Failed to save user",
    "userDeleted": "User \"{{username}}\" deleted successfully",
    "failedToDeleteUser": "Failed to delete user",
    "scrapingStarted": "Scraping job started successfully",
    "deleteUserTitle": "Delete User",
    "deleteUserMessage": "Are you sure you want to delete user \"{{username}}\"? This action cannot be undone."
  },
  "userList": {
    "loading": "Loading users...",
    "noUsers": "No users found",
    "active": "Active",
    "inactive": "Inactive",
    "notificationsEnabled": "Notifications enabled",
    "notificationsDisabled": "Notifications disabled",
    "created": "Created: {{date}}",
    "createdColumn": "Created",
    "never": "Never",
    "username": "Username",
    "email": "Email",
    "role": "Role",
    "status": "Status",
    "emailNotifications": "Email Notifications",
    "lastLogin": "Last Login",
    "actions": "Actions",
    "editUser": "Edit {{username}}",
    "deleteUser": "Delete {{username}}",
    "editUserTooltip": "Edit user",
    "deleteUserTooltip": "Delete user"
  },
  "userForm": {
    "editTitle": "Edit User",
    "createTitle": "Create New User",
    "usernameLabel": "Username",
    "usernameError": "Username must be at least 3 characters",
    "emailLabel": "Email",
    "emailError": "Valid email is required",
    "passwordLabel": "Password",
    "passwordEditLabel": "Password (leave blank to keep current)",
    "passwordRequired": "Password is required for new users",
    "passwordLength": "Password must be at least 8 characters",
    "passwordHelper": "Minimum 8 characters",
    "roleLabel": "Role",
    "roleUser": "User",
    "roleAdmin": "Admin",
    "activeLabel": "Active",
    "emailNotificationsLabel": "Email Notifications",
    "saving": "Saving...",
    "save": "Save"
  },
  "mortgage": {
    "title": "Mortgage Simulation Defaults",
    "description": "Default parameters used to compute the mortgage affordability simulation shown on ad detail pages. Any value can be overridden per-ad in the simulation itself.",
    "failedToLoad": "Failed to load mortgage settings",
    "failedToSave": "Failed to save mortgage settings",
    "saved": "Mortgage settings updated successfully",
    "saving": "Saving...",
    "save": "Save",
    "fields": {
      "min_down_payment_rate": "Minimum down payment (%)",
      "max_down_payment": "Maximum down payment (CHF)",
      "annual_income": "Household annual income (CHF)",
      "interest_rate": "Interest rate (%)",
      "term_years": "Fixed term (years)",
      "maintenance_rate": "Maintenance & charges (%)",
      "purchase_costs_rate": "Purchase costs (%)",
      "amortization_target_ltv": "Amortization target LTV (%)",
      "amortization_years": "Amortization period (years)",
      "stress_test_rate": "Stress-test rate (%)",
      "max_effort_ratio": "Max effort ratio (%)"
    }
  },
  "translations": {
    "title": "Ad Translations",
    "description": "Ad titles and short descriptions are translated eagerly at import time; full descriptions translate lazily the first time an ad is opened.",
    "failedToLoad": "Failed to load translation status",
    "failedToStart": "Failed to start re-translation",
    "started": "Re-translation started — this runs in the background.",
    "provider": "Provider",
    "disabled": "disabled",
    "adsInScope": "Ads in scope",
    "pending": "Pending",
    "failed": "Failed",
    "usage": "Provider usage: {{used}} / {{limit}} characters",
    "refresh": "Refresh",
    "dropAndRetranslate": "Drop & Re-translate",
    "confirmTitle": "Drop & Re-translate Ads",
    "confirmMessage_one": "This will delete the cached title/description translation for the {{count}} ad currently in scope (active, not discarded/not-interested/bought/retired) and re-translate it in the background. The cached full description is left untouched — it translates lazily the next time the ad is opened.",
    "confirmMessage_other": "This will delete cached title/description translations for the {{count}} ads currently in scope (active, not discarded/not-interested/bought/retired) and re-translate them in the background. Cached full descriptions are left untouched — they translate lazily the next time each ad is opened.",
    "confirmMessageUsage": " Current provider usage: {{used}} / {{limit}} characters."
  },
  "scraping": {
    "controls": {
      "automaticTitle": "Automatic Scraping",
      "loadingSchedule": "Loading schedule…",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "nextRun": "Next run: {{date}}",
      "frequency": "Frequency",
      "firstRunAt": "First run at",
      "firstRunHelper": "Set the date/time for the first scraping. Subsequent runs follow the frequency interval from this time.",
      "manualTitle": "Manual Scraping Controls",
      "manualDescription": "Manually trigger scraping for a specific website or all websites.",
      "starting": "Starting...",
      "runNow": "Run Now",
      "emailTitle": "Email Notifications",
      "sendNotificationTitle": "Send Notification Email",
      "sendNotificationDescription": "Manually send a notification email to all opted-in users with current new and backlog ads",
      "sending": "Sending...",
      "sendNow": "Send Now",
      "scrapers": {
        "all": { "label": "All Sites", "description": "Run scraping for all configured websites" },
        "immobilier_ch": { "label": "Immobilier.ch", "description": "Swiss real estate platform" },
        "homegate_ch": { "label": "Homegate.ch", "description": "Swiss real estate platform" },
        "comparis_immobilier": { "label": "Comparis", "description": "Swiss comparison platform" },
        "properstar_ch": {
          "label": "Properstar.ch",
          "description": "International property portal"
        },
        "anibis_ch": { "label": "Anibis.ch", "description": "Swiss classifieds platform" },
        "immoscout24_ch": {
          "label": "ImmoScout24.ch",
          "description": "Swiss real estate platform"
        },
        "newhome_ch": { "label": "Newhome.ch", "description": "Swiss real estate platform" }
      }
    },
    "jobList": {
      "status": "Status",
      "scraper": "Scraper",
      "all": "All",
      "running": "Running",
      "completed": "Completed",
      "partial": "Partial",
      "failed": "Failed",
      "refresh": "Refresh",
      "noJobs": "No scraping jobs found",
      "started": "Started: {{date}}",
      "duration": "Duration: {{duration}}",
      "scraped": "Scraped: {{count}}",
      "imported": "Imported: {{count}}",
      "updated": "Updated: {{count}}",
      "retired": "Retired: {{count}}",
      "id": "ID",
      "startedColumn": "Started",
      "durationColumn": "Duration",
      "scrapedColumn": "Scraped",
      "importedColumn": "Imported",
      "updatedColumn": "Updated",
      "retiredColumn": "Retired",
      "duplicatesColumn": "Duplicates",
      "trigger": "Trigger",
      "actions": "Actions",
      "viewLogs": "View Logs",
      "restartScraping": "Restart scraping",
      "allSites": "All Sites"
    },
    "logViewer": {
      "title": "Scraping Execution Logs",
      "close": "Close",
      "runDetails": "Run Details",
      "runId": "Run ID: {{id}}",
      "started": "Started: {{date}}",
      "searchPlaceholder": "Search logs...",
      "logLevel": "Log Level",
      "noLogsMatch": "No logs match your filters",
      "noLogsAvailable": "No logs available for this run",
      "showingLines_one": "Showing {{count}} line",
      "showingLines_other": "Showing {{count}} lines",
      "filtered": " (filtered)"
    }
  }
}
